import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'store/index';
import { OrderStatus, PickUpDropOffStatus } from 'types/orders';
import moment from 'moment/moment';
import orderBy from 'lodash.orderby';

const OrdersSelectors = (state: RootState) => state.orders;

export const selectAllOrders = createSelector(OrdersSelectors, (state) => {
  return orderBy(state.items, (o) => new Date(o.createdAt), ['desc']);
});

export const selectOrdersTotalCount = createSelector(
  OrdersSelectors,
  (state) => state.totalCount,
);
export const selectAllApprovedOrders = createSelector(
  OrdersSelectors,
  (state) =>
    state.items.filter((order) => order.status === OrderStatus.CONFIRMED),
);

export const selectAllPendingOrders = createSelector(
  OrdersSelectors,
  (state) => {
    return orderBy(
      state.items.filter((order) => order.status === OrderStatus.PENDING),
      (o) => new Date(o.createdAt),
      ['desc'],
    );
  },
);

export const selectOrdersPendingStatus = createSelector(
  OrdersSelectors,
  (state) => state.isPending,
);
export const selectSelectedOrder = createSelector(
  OrdersSelectors,
  (state) => state.selectedOrder,
);

export const selectPickupAndReturnsTab = createSelector(
  OrdersSelectors,
  (state) => state.pickupReturnsTab,
);

export const selectInProgressOrders = createSelector(
  OrdersSelectors,
  (state) => {
    return state.items.filter((item) =>
      moment.utc(item.rentEndDate).isSameOrAfter(moment.utc()),
    );
  },
);
export const selectOutboundCars = createSelector(
  selectInProgressOrders,
  (orders) => {
    return orderBy(
      orders.filter(
        (item) =>
          item.pickUpDropOffStatus === PickUpDropOffStatus.AWAITING_PICKUP &&
          item.status === OrderStatus.CONFIRMED,
      ),
      (o) => new Date(o.createdAt),
      ['desc'],
    );
  },
);

export const selectReturningCars = createSelector(
  selectInProgressOrders,
  (orders) => {
    return orderBy(
      orders.filter(
        (item) =>
          item.pickUpDropOffStatus === PickUpDropOffStatus.AWAITING_RETURN ||
          item.pickUpDropOffStatus === PickUpDropOffStatus.PICKED_UP,
      ),
      (o) => new Date(o.createdAt),
      ['desc'],
    );
  },
);

export const selectPendingCommentId = createSelector(
  OrdersSelectors,
  (state) => {
    return state.pendingCommentId;
  },
);

export const selectPendingOrders = createSelector(
  OrdersSelectors,
  (state) => state.pendingOrders,
);

export const selectPendingCount = createSelector(
  OrdersSelectors,
  (state) => state.pendingOrdersCount,
);

export const selectIsPendingOrdersLoading = createSelector(
  OrdersSelectors,
  (state) => state.isPendingOrdersLoading,
);

export const selectPaymentRefundPendingStatus = createSelector(
  OrdersSelectors,
  (state) => state.isRefundPending,
);
